import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-for-papers26',
  templateUrl: './call-for-papers.component.html',
  styleUrls: ['./call-for-papers.component.css']
})
export class CallForPapersComponent26 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
